<template>
    <div>

        <h2 class="mb-5 font-normal">
            Forgot Password
        </h2>

        <div class="mb-5 text-sm text-grey-dark">
            If you have forgotten your password, enter your email here and we'll send you a password reset email.
        </div>
        <TextInput
            v-model="email_"
            :invalid="$v.email_.$error"
            :success="!!successMessage"
            type="email"
            class="mb-5"
            label="Email"
            focused
            @enter="submit"
        >
            <template #errors>
                <div v-if="!$v.email_.required && $v.email_.$dirty">
                    Please enter your email address.
                </div>
                <div v-if="!$v.email_.email && $v.email_.$dirty">
                    Please enter a valid email address.
                </div>
            </template>
            <template #success>
                {{ successMessage }}
            </template>
        </TextInput>
        <div class="flex flex-wrap items-center">
            <Button
                text="Submit"
                @click="submit"
            />
            <div
                class="text w-full md:w-auto mt-4 md:mt-0 md:ml-6"
                @click="changeComponent('AuthModalSignIn')"
            >
                <div>
                    Remembered your password? <span class="font-semibold">Sign In</span>.
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import TextInput from '~/components/Input';
import Button from '~/components/Button';
import handleException from '../plugins/error-handler.client';

export default {

    components: {
        TextInput,
        Button,
    },

    props: {
        email: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            email_: '',
            successMessage: '',
        };
    },

    created() {
        this.email_ = this.email;
    },

    validations: {
        email_: {
            required,
            email,
        },
    },

    methods: {
        changeComponent(component) {
            this.$emit('change-component', {
                component,
                email: this.email_,
            });
        },
        submit() {
            this.$v.$touch();
            if (this.$v.$invalid) return;

            this.$axios.$post('/customer/forgot-password', {
                email: this.email_,
            })
                .then(() => {
                    this.successMessage = 'We have sent you an email.';
                })
                .catch((error) => {
                    handleException(error);
                });
        },
    },

};
</script>

<style lang="scss" scoped>
.text {
    @apply text-primary transition-fast cursor-pointer text-sm select-none;
    &:hover {
        @apply opacity-50;
    }
}
</style>
